import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MatInputModule, MatFormFieldModule, MatIconModule } from '@angular/material';

import { LandingRoutingModule, ROUTABLE_COMPONENTS } from './landing-aplicacion.routing';
import { TitlebarModule } from '../shared/titlebar/titlebar.module';
import { HeaderModule } from '../shared/header/header.module';
import { LoaderModule } from '../shared/loader/loader.module';
import { LandingComponent }    from './landing-aplicacion.component';

@NgModule({
    imports: [
        BrowserModule, FormsModule, ReactiveFormsModule, BrowserAnimationsModule,
        BrowserModule, HttpModule,
        MatFormFieldModule, MatIconModule, MatInputModule,
        LandingRoutingModule, HeaderModule, TitlebarModule, LoaderModule
    ],
    entryComponents: [],
    exports: [],
    declarations: [
        ROUTABLE_COMPONENTS,
        LandingComponent
    ],
    providers: [],
    bootstrap: []
})
export class LandingAplicacionModule {
}
